import { render } from "./MainBasicTrainingZone.vue?vue&type=template&id=5f6f4398&scoped=true"
import script from "./MainBasicTrainingZone.vue?vue&type=script&lang=js"
export * from "./MainBasicTrainingZone.vue?vue&type=script&lang=js"

import "./MainBasicTrainingZone.vue?vue&type=style&index=0&id=5f6f4398&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6f4398"]])

export default __exports__